export default "/images/storstroems_forsikring.webp?6ad9d128754084a93cf51848b9693302";